import {CloseButton} from '@headlessui/react'
import {useTranslation} from 'react-i18next'

import {IconArrowLeft, IconArrowRight, IconCross} from '@sdox/icons'

import {Button, useSlideshowContext} from '../../'
import {SlideshowThumbnails} from './Slideshow.Thumbnails'
import {SlideshowDotIndicators} from './Slideshow.DotIndicators'

export const SlideshowControls = () => {
  const {showPrevious, showNext, currentIndex, items} = useSlideshowContext()
  const {t} = useTranslation()

  return (
    <div className={'m-spacing-20 flex justify-between gap-spacing-16 md:m-0'}>
      <div className={'shrink-0'}>
        <CloseButton
          as={Button}
          variant={'overlay'}
          leading={<IconCross/>}
          size={'small'}
          aria-label={t('common:close')}
        />
      </div>
      <SlideshowThumbnails/>
      <SlideshowDotIndicators/>
      <div className={'hidden shrink-0 gap-spacing-8 md:flex'}>
        <Button
          variant={'overlay'}
          leading={<IconArrowLeft />}
          size={'small'}
          onClick={showPrevious}
          disabled={currentIndex === 0}
          aria-label={t('common:slideshow.previous')}
        />
        <Button
          variant={'overlay'}
          leading={<IconArrowRight />}
          size={'small'}
          onClick={showNext}
          disabled={currentIndex === items.length - 1}
          aria-label={t('common:slideshow.next')}
        />
      </div>
      <div className={'size-spacing-44 md:hidden'} />
    </div>
  )
}
